<template>
  <div class="popup-main">
    <el-dialog
      title="工序分组"
      width="1000px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
      append-to-body
      @close="popupCancel"
    >
      <div class="m-b-10">
        <!-- 表格操作条 -->
        <vxe-toolbar ref="refToolbar" size="mini" :loading="loading">
          <template #buttons>
            <el-button type="success" size="mini" @click="itemAdd">新增工序分组</el-button>
          </template>
        </vxe-toolbar>

        <!-- 表格 -->
        <vxe-grid
          ref="refTable"
          :loading="loading"
          :data="slefList"
          :columns="tableColumn"
          :max-height="this.$util.getViewHeight() - 300"
        >
          <!-- slot_default -->
          <template #default_operate="{ row }">
            <el-link type="primary" @click="itemEdit(row)">编辑</el-link>
            <el-link type="danger" @click="itemDelete(row)">删除</el-link>
          </template>
        </vxe-grid>
      </div>
    </el-dialog>

    <!-- 弹窗-增改工序分组 -->
    <PopupGroupDo
      v-if="isShowPopupGroupDo"
      :show.sync="isShowPopupGroupDo"
      :data.sync="itemObj"
      @success="getListData"
    />
  </div>
</template>

<script>
export default {
  components: { PopupGroupDo: () => import('./popup-group-do') },
  props: {
    show: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      slefList: [],
      loading: true,

      tableColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        {
          field: 'name',
          title: '工序分组名称'
        },
        { title: '操作', width: 160, slots: { default: 'default_operate' } }
      ],
      isShowPopupGroupDo: false,
      itemDefault: {
        id: '',
        name: '',
        type: '工序'
      },
      itemObj: {}
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.initItemObj()
    this.getListData()
  },
  methods: {
    // 初始化itemObj
    initItemObj() {
      this.itemObj = this.$util.deepCopy(this.itemDefault)
    },
    // 获取数据列表
    getListData() {
      this.loading = true
      this.$api({
        method: 'post',
        url: '/admin/gcvip/columnData/list',
        data: {
          type: '工序',
          sortData: {
            id: 'desc'
          }
        }
      })
        .then((res) => {
          if (res.status === 200) {
            this.slefList = res.data.list
          }
        })
        .catch(() => {})
        .then(() => {
          this.loading = false
        })
    },
    // 项-新增
    itemAdd() {
      this.isShowPopupGroupDo = true
      this.initItemObj()
    },
    // 项-编辑
    itemEdit(row) {
      this.isShowPopupGroupDo = true
      this.itemObj = this.$util.deepCopy(row)
    },
    // 项-删除
    itemDelete(row) {
      this.$confirm('您确认要删除该数据?', '提示')
        .then(() => {
          this.$api({
            method: 'get',
            url: '/admin/gcvip/columnData/delete',
            params: {
              id: row.id
            }
          }).then((res) => {
            if (res.status === 200 && res.data.state === 'ok') {
              this.$message.success('删除成功')
              this.getListData()
            }
          })
        })
        .catch(() => {})
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
      this.$emit('success')
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
}
</style>
